<template>
  <v-menu offset-x>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon color="primary" dark v-bind="attrs" v-on="on">
        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item @click="saveFavorite">
        <v-list-item-title>Add to favorites</v-list-item-title>
      </v-list-item>
      <v-list-item @click="openDialog">
        <v-list-item-title>Report job</v-list-item-title>
          <v-dialog v-model="dialog" scrollable max-width="300">
            <v-card>
              <v-card-title>Report</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-radio-group v-model="selection" column>
                  <v-radio
                    v-for="reason in reasonsToReport"
                    :label="reason.description"
                    :value="reason.label"
                    :key="reason.id"
                  ></v-radio>
                </v-radio-group>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn color="primary" text @click="dialog = false">
                  Cancel
                </v-btn>
                <v-btn color="primary" text @click="sendReport()">
                  Report
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: ["jobId"],
  data() {
    return {
      selection: "jobPostingExpired",
      dialog: false,
    };
  },
  mounted(){
    if (!this.$store.state.reasonsToReport) {
      this.$store
        .dispatch("dispatchReasonsToReport")
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => {
          console.log(this.$store.state.reasonsToReport);
        });
    }
  },
  computed: {
    reasonsToReport(){
      return this.$store.state.reasonsToReport;
    }
  },
  methods: {
    openDialog(){
      setTimeout(() => this.dialog = true);
    },
    reportData() {
      return {
        [this.selection]: true,
      };
    },
    sendReport() {
      if (this.selection != null) {
        let data = { reason: "" };
        data.reason = this.selection;
        console.log(data, this.jobId);
        this.$store
          .dispatch("dispatchReport", { jobId: this.jobId, report: data })
          .then((response) => console.log(response))
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.dialog = false;
          });
      }
    },
    saveFavorite(){
      this.$store.dispatch("commitFavorite", { jobId: this.jobId, action: 'add' });
    }
  },
};
</script>
